export default "<base-page [pageType]=\"pageType\"></base-page>"